import React from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';

// @tcc
import { getMessage } from 'util/locale';

import WarningIcon from 'common/WarningIcon';

const baseString = 'vra-dead-zone-warning';
const classString = classNames({
  [`${baseString}`]: true
});
const DeadZoneWarning = ({ hasDeadZone }) => hasDeadZone ? (
  <section className={classString}>
    <WarningIcon />
    <p>{getMessage('help-text__dead-zone')}</p>
  </section>
) : null;
DeadZoneWarning.propTypes = {
  hasDeadZone: propTypes.bool.isRequired
};
export default DeadZoneWarning;
